"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/notification/types");
var initialState = {
  show: false
};
function notification() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  if ([_types.SHOW_NOTIFICATION, _types.CLEAR_NOTIFICATION].includes(type)) {
    return payload;
  }
  return state;
}
var _default = exports["default"] = notification;